<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="FinancesOverview")
    h1.title Rechnungserstellung
    .sub-headline Hier können Sie eine neue Rechnung erstellen.

    //- b-message.margin-top(type='is-danger' has-icon='')
    //-   | Diese Funktionalität befindet sich derzeit im Aufbau und ist als Beta-Funktion in Absprache mit Kerstin Bruns zu testen.
    
    FinanceInvoices(:owners="owners" :rentObjects="rentObjects")
</template>

<script>
import FinanceInvoices from '@/components/organisms/FinanceInvoices.vue'

export default {
  components: {
    FinanceInvoices,
  },
  data() {
    return {
      
    };
  },
  computed: {
    owners() {
      return this.$store.state.owners.all;
    },
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
  },
  methods: {
  },
  async mounted() {
    this.$store.dispatch("owners/findAll");
    this.$store.dispatch("rentObjects/findAll");
  }
};
</script>

<style lang="scss" scoped>
</style>